import CommonColorUtils from "../../../../utils/common_colors";

export function rtoStatusAccordingToStatusCode(status) {
    return status === 149 ? "RTO Completed" : "RTO Pending";
}

export function rtoStatusColorAccordingToStatusCode(status) {
    return status === 149 ? CommonColorUtils.primarySuccessDarkGreen : CommonColorUtils.kSecondaryAlert500;
}

export function pickupStatusAccordingToStatusCode(status) {
    return [101, 102, 103].includes(status) ? "Pickup pending" : "Pickup Completed";
}
export function pickupStatusColorAccordingToStatusCode(status) {
    return [101, 102, 103].includes(status) ?  CommonColorUtils.kSecondaryAlert500: CommonColorUtils.primarySuccessDarkGreen;
}

export function returnStatusAccordingToStatusCode(index) {
    switch (index) {
        case 130:
        case 131:
            return "Return pending";
        case 132:
            return "Return Completed";
        case 133:
            return "RETURN_CANCELLED";
        case 134:
            return "ON_HOLD";
        case 135:
            return "LOST";
        case 136:
            return "DAMAGED";
        case 137:
            return "SHIPMENT_DELAYED";
        case 138:
            return "SHIPMENT_HELD";
        default:
            return "";
    }
}

export function returnStatusColorAccordingToStatusCode(index) {
    switch (index) {
        case 130:
        case 131:
            return CommonColorUtils.kSecondaryAlert500;
        case 132:
            return CommonColorUtils.primarySuccessDarkGreen;
        case 133:
        case 134:
        case 135:
        case 136:
        case 137:
        case 138:
            return 'black';
        default:
            return 'black';
    }
}